<template>
  <v-container class="pt-7 setting-container">
    <div>
      <div class="card-title pl-2 font-weight-medium">
        {{ title }}
      </div>
      <div class="card-sub-title pl-5 grey-7--text text-body-2 mt-1">
        {{ subtitle }}
        <br>
        若有相關問題可參考
        <a :href="`${$enum.DENTCO_NOTION_HOST}/1-216deb39b5da41f3afd4523b28240aff`" target="_blank" class="link_blue--text">操作說明</a>
        或
        <a :href="$enum.DENTCO_CS_LINE" target="_blank" class="link_blue--text">聯繫客服</a>
      </div>
    </div>
    <div v-if="!hasPermission" class="mt-7">
      <v-btn
        dark
        color="tiffany-10"
        depressed
        :block="$vuetify.breakpoint.smAndDown"
        class="px-md-12 rounded-lg"
        href="https://lin.ee/mWs8BoE"
        target="_blank"
      >
        欲顯示衛教相簿，請點我升級為進階方案
      </v-btn>
    </div>
    <div class="content mt-7">
      <ClinicHealthEducationSharing :has-permission="hasPermission" />
    </div>
  </v-container>
</template>

<script>
import ClinicHealthEducationSharing from '@/components/settings/clinic/ClinicHealthEducationSharing.vue';
import { checkPermissions } from '@/utils/tool';

export default {
  name: 'ClinicHealthEducationSharingWrapper',

  components: {
    ClinicHealthEducationSharing
  },

  props: {
    title: {
      required: true,
      type: String
    },
    subtitle: {
      required: true,
      type: String
    },
    plan: {
      required: true,
      type: String
    },
    userInfo: {
      required: true,
      type: Object
    }
  },

  computed: {
    hasPermission() {
      return checkPermissions({obj: this.userInfo, type: 'clinic', permissions: this.pagePermission})
    }
  },

  data() {
    return {
      pagePermission: ['adv_page']
    }
  }
}
</script>

<style scoped lang="scss">
.setting-container {
  max-width: 1200px;

  .card-title {
    border-left: 10px solid var(--v-tiffany-10-base);
    color: var(--v-tiffany-10-base);
    font-size: 18px;
  }
}
</style>
